const BASE = '/api';
async function request(path, options) {
    const res = await fetch(`${BASE}${path}`, {
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({ error: 'Request failed' }));
        throw new Error(err.error || `HTTP ${res.status}`);
    }
    const body = await res.json();
    return body.data;
}
export const api = {
    auth: {
        me: () => request('/auth/me'),
        requestAccess: (body) => request('/auth/request-access', { method: 'POST', body: JSON.stringify(body) }),
        acceptInvite: (body) => request('/auth/accept-invite', { method: 'POST', body: JSON.stringify(body) }),
    },
    organisations: {
        list: () => request('/organisations'),
        create: (body) => request('/organisations', { method: 'POST', body: JSON.stringify(body) }),
    },
    users: {
        byOrg: (orgId) => request(`/users/by-org/${orgId}`),
        invite: (body) => request('/users/invite', { method: 'POST', body: JSON.stringify(body) }),
    },
    projects: {
        mine: () => request('/projects/mine'),
        byOrg: (orgId) => request(`/projects/by-org/${orgId}`),
        create: (body) => request('/projects', { method: 'POST', body: JSON.stringify(body) }),
    },
    deliverables: {
        byProject: (projectId) => request(`/deliverables/by-project/${projectId}`),
        create: (body) => request('/deliverables', { method: 'POST', body: JSON.stringify(body) }),
        uploadFile: (id, file) => fetch(`${BASE}/deliverables/${id}/upload`, {
            method: 'PUT',
            headers: { 'Content-Type': file.type },
            body: file,
        }),
        downloadUrl: (id) => `${BASE}/deliverables/${id}/download`,
    },
    leads: {
        list: () => request('/leads'),
    },
    gdpr: {
        export: () => request('/gdpr/export'),
        deleteRequest: () => request('/gdpr/delete-request', { method: 'POST' }),
    },
    campaigns: {
        list: () => request('/campaigns'),
        get: (id) => request(`/campaigns/${id}`),
        create: (body) => request('/campaigns', { method: 'POST', body: JSON.stringify(body) }),
        updateStatus: (id, status) => request(`/campaigns/${id}/status`, { method: 'PATCH', body: JSON.stringify({ status }) }),
        addInvites: (id, emails) => request(`/campaigns/${id}/invites`, { method: 'POST', body: JSON.stringify({ emails }) }),
        sendInvites: (id) => request(`/campaigns/${id}/send-invites`, { method: 'POST' }),
        analyse: (id) => request(`/campaigns/${id}/analyse`, { method: 'POST' }),
        responses: (id) => request(`/campaigns/${id}/responses`),
    },
    reports: {
        downloadUrl: (campaignId, lang) => `/api/reports/${campaignId}/pdf?lang=${lang}`,
    },
    templates: {
        list: () => request('/templates'),
    },
};
